module.exports = "/images/frau-6.jpg?cbad4c7e3601ea0ff4fa62a76681fc7f";